import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return createPortal(<AnimatePresence data-id="element-235">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-236">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-237" />

          {/* Panel */}
          <motion.div role="dialog" aria-modal="true" aria-label={title} initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="relative z-10 w-full max-w-2xl max-h-[85vh] flex flex-col bg-tactical-surface border border-tactical-cyan/30 rounded-2xl box-glow overflow-hidden" data-id="element-238">
            <div className="flex items-center justify-between px-6 py-5 border-b border-tactical-surface2 shrink-0" data-id="element-239">
              <h2 className="text-2xl text-white" data-id="element-240">{title}</h2>
              <button onClick={onClose} aria-label="Close" className="w-9 h-9 flex items-center justify-center rounded-lg text-slate-400 hover:text-white hover:bg-tactical-dark transition-colors" data-id="element-241">
                <X className="w-5 h-5" data-id="element-242" />
              </button>
            </div>

            <div className="px-6 py-6 overflow-y-auto font-inter text-slate-300 leading-relaxed space-y-4" data-id="element-243">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>, document.body);
}